import React from 'react';

import { LAYOUT, COLOR } from "../../modules/constants";

import { withStyles } from '@mui/styles';
import List from '@mui/material/List';

const styles = () => ({
  searchIcon: {
    fontSize: 30,
    marginRight: 10,
    marginTop: 7,
    color: "white",
  },
  titleItem: {
    paddingTop: 2,
    paddingBottom: 11,
    paddingLeft: 20,
    marginBottom: 12,
    background: COLOR.HUB,
  },
  titleText: {
    fontSize: 20,
    fontWeight: "bold",
    color: "white",
    lineHeight: 1.2,
    marginTop: 5,
    marginBottom: 0,
  },
  searchMenuList: {
    paddingTop: 0,
  }
});

const SearchMenu = ({ classes, children, portrait }) => (
  <div className={portrait ? "menu-search-portrait" : "menu-search-landscape"}
    style={portrait
      ? { background: COLOR.BACKGROUND }
      : {
        width: `${LAYOUT.SEARCH_LANDSCAPE_MENU_WIDTH}px`,
        minWidth: `${LAYOUT.SEARCH_LANDSCAPE_MENU_WIDTH}px`,
        borderRight: "1px solid lightgrey",
        background: COLOR.BACKGROUND
      }} >
    <List component="nav" className={classes.searchMenuList}>
      <div className="menu-scrollBody">{children}</div>
    </List>
  </div>
);

export default withStyles(styles)(SearchMenu);
